import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import { useHistory } from "react-router";
import RenderInputError from "../../pages/Login/RenderInputError/RenderInputError";
import OtpInitialValues from "../../entities/OtpInitialValues";
import { OtpVerify } from "../../services/OtpVerify";
import { useDispatch, useSelector } from "react-redux";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import ErrorPopup from "../ErrorPopup/ErrorPopup";
import { OtpSend, otpSendUtil } from "../../services/OtpSend";
import CircleLoading from "../CircleLoading/CircleLoading";
import {
  setHaveMessages,
  setIsAmit,
  setIsOnline,
  setIsPensioner,
  setIs101ButtonAllowed,
  setIsSendAgainPossible,
  setIsSendAgainPossibleDate,
  setIsSuspend,
  setMapUserFunds,
  setUserFirstName,
  setUserFunds,
  setUserLastName,
  sethaveYearlyReports,
  setIsFileFound,
  setIsEnteredFromToShowFile,
} from "../../state/actions/UserActions";
import { GetMemberFunds } from "../../services/GetMemberFunds";
import {
  GetMemberDetails,
  memberDetailsUtil,
  MEMBER_QUESTIONS_NO_DATA,
} from "../../services/GetMemberDetails";
import { getUserFunds } from "../../services/getUserFunds";
import OtpProps from "./OtpProps";
import { otpVerifyUtil } from "../../services/OtpVerify";
import { isEnterPress } from "../../utils/helpers/accessibilityUtil";
import CustomInput from "../CustomInput/CustomInput";
import "./Otp.scss";
import { getCmDocById, getDocBytes } from "../../services/CmService";
import openBase64NewTab from "../../utils/PdfCreator/PdfCreator";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import { GetDashboradData } from "../../services/Dashboard.service";
import {
  setIsDoc,
  setPensionDataRedux,
  setRedemptionRightDataRedux,
  setRightsPerEmpRedux,
  setSalaryDataRedux,
} from "../../state/actions/DashboardActions";
import useInputFocus from "../../customHooks/useInputFocus";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import RenderTime from "../LoderCountdown/LoderCountdown";
import { waitimgTimeToSendAgaininMiliSeconds, waitimgTimeToSendAgainInSECONDS } from "../../pages/Login/Login";
import { downloadAdaMemberDocument, getAdaMemberDocumentsByParams, downloadAdaMemberDocumentForViewDoc, getAdaMemberDocumentsBySourceMenuID } from "../../services/ADAService";
import { CmConstants } from "../../utils/constants/CmConstants";
import { isHaveYearlyReports } from "../../utils/helpers/MemberDataHelper";
import { Get101ButtonIsAllowed } from "../../services/Get101ButtonIsAllowed";
import { screenSize } from "../../utils/helpers/screenSize";
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { OTPVerifyForViewDoc } from "../../services/OtpVerifyForViewDoc";
import session from "redux-persist/lib/storage/session";
import { deepLinkOTPSend } from "../../services/deepLinkOTPSend";

export const suspensionTimeInMiliseconds = 60 * 1000 * 60
let ramVal:any = null

const Otp = (props: OtpProps) => {
  const { isSuspend, isSendAgainPossible } = useSelector(
    (state: any) => state.UserReducer
  );
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("common");

  const { userId, isSendAgainPossibleDate, isEnteredFromToShowFile } = useSelector((state: any) => state.UserReducer);
  const [isOtpError, setOtpError] = useState<boolean>(false);
  const [clickbtnsub, setClickbtnsub] = useState<boolean>(false);
  const [isNotSixDigitsLongOtp, setIsNotSixDigitsLongOtp] =
    useState<boolean>(false);
  const [isSendAgainError, setSendAgainError] = useState<boolean>(false);
  const [isSendAgainPossibleTimeLeft, setisSendAgainPossibleTimeLeft] =
    useState<number>(waitimgTimeToSendAgainInSECONDS);
  const submitRef = useRef<any | null>(null);

  const { width } = useWindowDimensions();
  const isMobile = width <= screenSize.headerSziem;
  const { issueDate } = useSelector((state: any) => state.UserReducer);

  const [loading, setLoading] = useState<boolean>(false);
  const validate = (values: OtpInitialValues) => {
    const errors: any = {};


    const regexIsAllDigits = /^\d+$/

    if (!isSuspend) {
      if (values.enteredOtpCode.length > 6) {
        errors.enteredOtpCode = t("Otp.inputError");
      } else if (
        values.enteredOtpCode.length > 0 &&
        !regexIsAllDigits.test(values.enteredOtpCode)
      ) {
        // check for every digit that is a number
        errors.enteredOtpCode = t("Otp.inputError");
      } else if (
        // handle all zeros case
        values.enteredOtpCode
          .split("")
          .filter((digit: string) => parseInt(digit) === 0).length === 6
      ) {
        errors.enteredOtpCode = t("Otp.inputError");
      }

      if (isNotSixDigitsLongOtp || values.enteredOtpCode.length == 0) {
        errors.enteredOtpCode = t("Otp.inputError");
      }
    }
    if (isOtpError || isSendAgainError || isSuspend) {
      errors.enteredOtpCode = isSendAgainError
      ? t("Otp.sendAgainError")
      : isSuspend
        ? t("BankAccountVerify.sendAgainError") :
        t("Otp.codeNotValid")
    }
    if (ramVal !== values) {
      setIsNotSixDigitsLongOtp(false);
      setSendAgainError(false);
      setOtpError(false);
    }
    ramVal = values;

    return errors;
  };

  const formik: any = useFormik({
    initialValues: {
      enteredOtpCode: "",
    },
    validate,
    onSubmit: async (values: OtpInitialValues) => {
      if (
        !isSuspend &&
        values.enteredOtpCode.length === 6 &&
        values &&
        userId.length
      ) {
        setLoading(true);
        const token = !(sessionStorage.getItem("isEnteredFromToShowFile") == 'true') ? await OtpVerify(userId, values.enteredOtpCode) : await OTPVerifyForViewDoc(userId, values.enteredOtpCode);
        
        if (otpVerifyUtil.isSuccess(token)) {
          sessionStorage.setItem("token", token);
          if (!(sessionStorage.getItem("isEnteredFromToShowFile") == 'true')) { 
            GetDashboradData().then(async (results) => {
              dispatch(setPensionDataRedux(results[0]));
              dispatch(setRedemptionRightDataRedux(results[1]));
              dispatch(setRightsPerEmpRedux(results[2]));
              dispatch(setSalaryDataRedux(results[3]));
              const is101ButtonAllowed = await Get101ButtonIsAllowed();
              dispatch(setIs101ButtonAllowed(is101ButtonAllowed))
              initUserData();
            })
          }
          else{
            handleDeepLinkingNav();           
           
          }
          
        } else if (otpVerifyUtil.isMaxServerRequestsError(token)) {
          dispatch(setIsSuspend(true));
          setTimeout(
            () => dispatch(setIsSuspend(false)),
            suspensionTimeInMiliseconds
          );
          isOtpError && setOtpError(false);
          isSendAgainError && setSendAgainError(false);
          setLoading(false)

        } else {
          const timeToSendAgainPosibbleInSeconds =
            (isSendAgainPossibleDate.getTime() - new Date().getTime()) / 1000;
          setisSendAgainPossibleTimeLeft(timeToSendAgainPosibbleInSeconds);
          dispatch(setIsSuspend(false));
          isSendAgainError && setSendAgainError(false);
          setOtpError(true);
          setLoading(false)

        }
      }

      else if (values.enteredOtpCode.length !== 6) {
        setIsNotSixDigitsLongOtp(true)
      }
    },
  });

  useEffect(() => {
    if (isMobile && "OTPCredential" in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ["sms"] },
          signal: ac.signal,
        })
        .then((otp) => {
          formik.setFieldValue("enteredOtpCode", otp?.code);
        })
        .catch((err) => {
          ac.abort();
          console.log(err);
        });

        setTimeout(() => ac.abort(), 5 * 60 * 1000);
    }
  });

  const initUserData = async () => {
    Promise.all([
      GetMemberDetails(),
      GetMemberFunds(),
      getAdaMemberDocumentsBySourceMenuID(
        sessionStorage.token.toUpperCase(),
        null,
        "",
        CmConstants.Reports.SourceMenuId
      ),
    ])
      .then(async (results) => {
        const userDetails = results[0];
        const userFundsData = results[1];
        const userReports = results[2];
        if (
          !(memberDetailsUtil.isValid(userDetails) && userFundsData?.length)
        ) {
          if (
            userDetails === MEMBER_QUESTIONS_NO_DATA &&
            userFundsData.length
          ) {
            history.push("/privacy-questions");
          } else {
            dispatch(setModalState(true));
            dispatch(
              setModalChild(
                <ErrorPopup size="m" label={t("general.error")} center={true} />
              )
            );
            history.push("/register");
            history.push("/login");
          }
        } else {
          const { userFunds, isAmit, isPensioner, haveMessages } =
            await getUserFunds(userFundsData);
          dispatch(setIsDoc(userReports?.length > 0 ? true : false));
          const HaveYearlyReports = isHaveYearlyReports(userReports);
          dispatch(sethaveYearlyReports(HaveYearlyReports));

          dispatch(setUserFirstName(userDetails.firstName));
          dispatch(setUserLastName(userDetails.lastName));
          let mapUserFunds = new Map(
            userFunds.map((obj: any) => {
              return [obj.fundCode, obj];
            })
          );
          dispatch(setMapUserFunds(mapUserFunds));
          dispatch(setUserFunds(userFunds));
          isAmit && dispatch(setIsAmit(isAmit));
          isPensioner && dispatch(setIsPensioner(isPensioner));
          dispatch(setHaveMessages(haveMessages));
          dispatch(setIsOnline(true));
          handleDeepLinkingNav();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getSendAgainSuspensionStatus = () => {
    // return true if sendAgainSuspensionDate is exist in local storage and
    // current date is bigger than suspension date
    // dispatch(setIsSuspend(false))
    const sendAgainSuspensionDate = localStorage.getItem(
      "sendAgainSuspensionDate"
    );
    const currentDate = new Date();
    const isCurrentDateBiggerthanSuspensionDate =
      sendAgainSuspensionDate &&
      currentDate >= new Date(sendAgainSuspensionDate);
    if (isCurrentDateBiggerthanSuspensionDate) {
      dispatch(setIsSuspend(true));
      setTimeout(
        () => dispatch(setIsSuspend(false)),
        suspensionTimeInMiliseconds
      );
    }
    return isCurrentDateBiggerthanSuspensionDate;
  };

  const setSuspensionDate = () => {
    const suspensionDate = new Date();
    suspensionDate.setMinutes(suspensionDate.getMinutes() + 10);
    localStorage.setItem("sendAgainSuspensionDate", suspensionDate.toString());
  };

  const getSendAgainCount = () => {
    const sendAgainCount = sessionStorage.getItem("sendAgainCount");
    const isUserSuspended = getSendAgainSuspensionStatus();
    if (!sendAgainCount || isUserSuspended) {
      isUserSuspended && localStorage.removeItem("sendAgainSuspensionDate");
      return 0;
    } else if (parseInt(sendAgainCount) === 5) {
      setSuspensionDate();
    }
    return parseInt(sendAgainCount);
  };

  const sendAgainOtpCode = async () => {
    if (!isSuspend) {
      resetOtpFields();
      isOtpError && setOtpError(false);
      setLoading(true);
      if(!(sessionStorage.getItem("isEnteredFromToShowFile") == 'true')){
        const isValidNewCode = await OtpSend(
          userId,
          props.emailSelected ? 0 : 1,
          props.enteredCellphoneNumber ? props.enteredCellphoneNumber : "",
          props.enteredEmail ? props.enteredEmail : "");
        
        if (!otpSendUtil.isSuccess(isValidNewCode)) {
          if (otpSendUtil.isMaxServerRequestsError(isValidNewCode)) {
            dispatch(setIsSuspend(true))
            setTimeout(() => dispatch(setIsSuspend(false)), suspensionTimeInMiliseconds)
          }
          else {
            dispatch(setIsSuspend(false))
            setSendAgainError(true);
          }
        }
        if (otpSendUtil.isSuccess(isValidNewCode) && isSendAgainError) {
          // case if sendAgainError is true, clean up.
          if (otpSendUtil.isMaxServerRequestsError(isValidNewCode)) {
            dispatch(setIsSuspend(true))
            setTimeout(() => dispatch(setIsSuspend(false)), suspensionTimeInMiliseconds)
          }
          else {
            dispatch(setIsSuspend(false))
          }
        }
      }
      else {
        const submitStatus = await deepLinkOTPSend(
          sessionStorage.getItem("requestID") || "",
          userId,
          props.emailSelected ? 0 : 1,
          props.enteredCellphoneNumber ? props.enteredCellphoneNumber : "",
          props.enteredEmail ? props.enteredEmail : "",
          issueDate
        );

        if (typeof (submitStatus) == "boolean" && submitStatus) {
          localStorage.setItem("userId", userId); //set userid to localstorage
          dispatch(setIsSuspend(false));
        }

      }
    }
    let date = new Date();
    date.setSeconds(date.getSeconds() + waitimgTimeToSendAgainInSECONDS);
    dispatch(setIsSendAgainPossibleDate(date));
    dispatch(setIsSendAgainPossible(false));
    setTimeout(
      () => dispatch(setIsSendAgainPossible(true)),
      waitimgTimeToSendAgaininMiliSeconds
    );
    setisSendAgainPossibleTimeLeft(waitimgTimeToSendAgainInSECONDS);
    setLoading(false);
  };

  const resetOtpFields = () => {
    formik.resetForm();
  };

  const InputFocus = useInputFocus(
    formik.errors,
    formik.submitCount,
    clickbtnsub
  );
  useEffect(() => {
    if (InputFocus) {
      setClickbtnsub(false);
    }
  }, [InputFocus]);

  useEffect(() => {
    if (formik.values.enteredOtpCode.length === 6 && isMobile) {
      formik.handleSubmit();
    }
  }, [formik.values.enteredOtpCode]);

  const handleDeepLinkingNav = () => {
    
    const goto = sessionStorage.getItem("goto");
    if (goto?.length) {
      if (isInRoutes(goto)) {
        history.push(`/${goto}`);
      } else if (goto.includes("docdata") || goto.includes("docData")) {
        
        // dispatch(setIsEnteredFromToShowFile(true))
        handleDocDeepLinking(goto);
      }
      // sessionStorage.removeItem("goto");
    } else {

      history.push("/");
    }
  };


  const handleDocDeepLinking = async (goto: string) => {
    const docDataArray = goto.toUpperCase().split("DOCDATA:").join("").split(",");
    // const [userId, docMenuId, userType, dateValue, fundCode] = docDataArray;
    let [docMenuId] = docDataArray;
    const docMenuIdNumber =  Number(docMenuId);
    let file: any = await downloadAdaMemberDocumentForViewDoc(sessionStorage.token.toUpperCase()).then((res:any)=> res.fileContent) 
    const pdfData = file

    pdfData && openBase64NewTab(pdfData, false, true);
    pdfData && backToLogin();
    setLoading(false);
    !pdfData && dispatch(setIsFileFound(false))
    //dispatch(setIsEnteredFromToShowFile(false))

  };

  const isInRoutes = (goto: string) =>
    goto === "reports" ||
    goto === "deposits" ||
    goto === "contact" ||
    goto === "register" ||
    goto === "my-details" ||
    goto === "privacy-questions";

  const backToLogin = () => {
    setOtpError(false);
    if (props.emailSelected) {
      props.setRadioValue(t("Login.radioValue1"));
    } else {
      props.setRadioValue(t("Login.radioValue2"));
    }
    props.setFormSubmitted(false);
  };

  const getEncodedCellphone = () => {
    if (props.enteredCellphoneNumber && props.enteredCellphoneNumber.length) {
      let formatCellphoneNumber = !props.enteredCellphoneNumber.includes("-")
        ? insert(props.enteredCellphoneNumber, 3, "-")
        : props.enteredCellphoneNumber;
      formatCellphoneNumber = replaceRange(
        formatCellphoneNumber,
        6,
        formatCellphoneNumber.length - 1,
        "XXXX"
      );
      return formatCellphoneNumber;
    }
    return "";
  };

  const getEncodedEmail = () => {
    if (props.enteredEmail && props.enteredEmail.length) {
      const indexIndicator = props.enteredEmail.indexOf("@");
      return replaceRange(
        props.enteredEmail,
        indexIndicator - 3,
        indexIndicator,
        "XXXX"
      );
    }
    return "";
  };

  function insert(str: any, index: number, value: any) {
    if (str && value) {
      return str.substr(0, index) + value + str.substr(index);
    }
    return "";
  }

  function replaceRange(
    s: any,
    start: number,
    end: number,
    substitute: string
  ) {
    if (s && substitute) {
      return s.substring(0, start) + substitute + s.substring(end);
    }
    return "";
  }

  useDidMountEffect(() => {
    formik.validateForm();
  }, [i18n.language, isOtpError, isOtpError]);

  return loading ? (
    <CircleLoading />
  ) : (
    <form onSubmit={formik.handleSubmit}>
      <div className="mobile-background">
        <h1>{(sessionStorage.getItem("isEnteredFromToShowFile") == 'true')? t("Login.titleFile"): t("Login.title")}</h1>
        <div className="otp-labels-wrapper">
          {props.emailSelected ? (
            <>
              <span>
                {`${t("Otp.codeSendMail")} `} {getEncodedEmail()}
              </span>
            </>
          ) : (
            <>
              <span>{`${t("Otp.codeSend")} `} </span>
              <span>{getEncodedCellphone()}</span>
            </>
          )}
          <span>{t("Otp.insertcode")}</span>
        </div>
        <div className="wrap-inputs-otp">
          <CustomInput
            ariaDescription="הקוד תקף ל-5 דקות, וניתן לבקש שליחת קוד חוזרת עוד 60 שניות"
            formik={formik}
            fullWidth={true}
            keyString="enteredOtpCode"
            inputLabel={t("Otp.inputLabel")}
            tooltipLabel={t("Otp.tooltipLabel")}
            withIcon={true}
            withTooltip={true}
            maxLength={6}
            autoFocus={true}
            htmlFor={"enteredOtpCode"}
            ariaDescribedby={"enteredOtpCode"}
             
          />
        </div>
        {/* {(isOtpError || isSendAgainError || isSuspend) && (
          <div className="otp-error-render-wrapper">
            <RenderInputError
              errorLabel={
                isSendAgainError
                  ? t("Otp.sendAgainError")
                  : isSuspend
                    ? t("BankAccountVerify.sendAgainError") :
                    t("Otp.codeNotValid")
              }
            />
          </div>
        )} */}
      </div>

      <div className="wrap-btns-otp">
        <button
          id="login-submit-button"
          ref={submitRef}
          className="login-submit-button otp-button-mt"
          type="submit"
          onClick={() => setClickbtnsub(true)}
        >
          <span>{t("Otp.enter")}</span>
        </button>

        <div className="otp-final-labels-wrapper">
          {(isSendAgainPossible || (!isSendAgainPossible && isSuspend)) ? (
            <>
              <button
                className="btn-rm-st text-btn"
                onMouseDown={sendAgainOtpCode}
                onKeyPress={(event) =>
                  isEnterPress(event) && sendAgainOtpCode()
                }
              >
                {t("Otp.sendAgainCode")}
              </button>

              <button
                className="btn-rm-st text-btn"
                onMouseDown={backToLogin}
                onKeyPress={(event) => isEnterPress(event) && backToLogin()}
              >
                {props.emailSelected
                  ? t("Otp.codeToPhone")
                  : t("Otp.codeToMail")}
              </button>
            </>
          ) : (
            <div className="timer-wrapper">
              <CountdownCircleTimer
                strokeWidth={8}
                size={50}
                isPlaying
                duration={waitimgTimeToSendAgainInSECONDS}
                initialRemainingTime={isSendAgainPossibleTimeLeft}
                colors={["#0250C1", "#80a2ff", "#a5bdff"]}
                colorsTime={[isSendAgainPossibleTimeLeft / 2, 0]}
              >
                {RenderTime}
              </CountdownCircleTimer>
              {t("Login.codeOneTheWay")}
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default Otp;
